import { ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { BKJSideModal } from 'components/BKJSideModal/BKJSideModal';
import {
  shiftModalRoutingService,
  useShiftModalUIContext,
} from 'modals/ShiftModal/ShiftModal.ui.context';
import { ShiftModalHeaderMap } from 'modals/ShiftModal/ShiftModalHeaders';
import { ShiftModalViewsWithTabs } from 'modals/ShiftModal/ShiftModal.constants';
import { ShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { ShiftModalErrorView } from 'modals/ShiftModal/src/views/ShiftModalErrorView';
import { FC } from 'react';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export const ShiftModalTemplate: FC = ({ children }) => {
  const { isOpen, shiftModalActiveModalView } = useShiftModalUIContext();

  return (
    <BKJSideModal
      data-testid="J360ShiftModal"
      isOpen={isOpen}
      context={ShiftModalDataContext}
      errorComponent={ShiftModalErrorView}
      onClose={shiftModalRoutingService.close}
      onBack={shiftModalRoutingService.goToPrevView}
      headerComponent={ShiftModalHeaderMap[shiftModalActiveModalView]}
      hasTabs={ShiftModalViewsWithTabs.includes(shiftModalActiveModalView)}
      showBackButton={shiftModalRoutingService.isBackButtonVisible()}
    >
      <ErrorBoundary
        componentName="ShiftModal"
        showLogo={!WhiteLabelAccessor.isWhiteLabelled()}
        errorComponent={ShiftModalErrorView}
      >
        {children}
      </ErrorBoundary>
    </BKJSideModal>
  );
};
